export default __webpack_public_path__ + "static/media/landscape12.870ea20c.jpeg";